export * from './device-type';
